import { handleActions } from 'redux-actions';
import { setContainerScrollTop } from 'store/actions/container-scroll-top-actions';

const DEFAULT = 0;

export default handleActions(
    {
        [setContainerScrollTop]: (_, { payload}) => {
            return payload;
        },
    }, DEFAULT);